/* tslint:disable */
import {
  Reward,
  Player
} from '../index';

declare var Object: any;
export interface PlayerRewardInterface {
  "id"?: any;
  "rewardId"?: any;
  "playerId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  reward?: Reward;
  player?: Player;
}

export class PlayerReward implements PlayerRewardInterface {
  "id": any;
  "rewardId": any;
  "playerId": any;
  "createdAt": Date;
  "updatedAt": Date;
  reward: Reward;
  player: Player;
  constructor(data?: PlayerRewardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerReward`.
   */
  public static getModelName() {
    return "PlayerReward";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerReward for dynamic purposes.
  **/
  public static factory(data: PlayerRewardInterface): PlayerReward{
    return new PlayerReward(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerReward',
      plural: 'player-rewards',
      path: 'player-rewards',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
        "rewardId": {
          name: 'rewardId',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        reward: {
          name: 'reward',
          type: 'Reward',
          model: 'Reward',
          relationType: 'belongsTo',
                  keyFrom: 'rewardId',
          keyTo: 'id'
        },
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
      }
    }
  }
}
